import BaseService from '../base';
import {
  IRechargePanelRequest,
  BizID,
  ICreateOrderRequest,
  IQueryOrderRequest,
} from './types';
import { getEnv } from '@/common/env';

const getCashierBase = () => {
  const env = getEnv();
  const URL_MAP = {
    dev: '//uat-www.bilibili.tv',
    uat: '//uat-www.bilibili.tv',
    pre: '//pre-www.bilibili.tv',
    prod: '//www.bilibili.tv',
  };
  return URL_MAP[env];
};

class PaymentService extends BaseService {
  getRechargePanel() {
    const params: IRechargePanelRequest = {
      platform: 'web',
      biz_id: BizID.LIVE_GIFT,
    };
    return this.get({
      url: '/web/wallet/stars/recharge/panel',
      params,
    });
  }

  createOrder(
    product_id: string, product_code: string, // from product
    pay_channel: string, pay_channel_id: string, sub_pay_channel_id: number, // from channel
    return_url?: string
  ) {
    const data: ICreateOrderRequest = {
      biz_id: BizID.LIVE_GIFT,
      product_id,
      product_code,
      pay_channel,
      pay_channel_id,
      sub_pay_channel_id,
      return_url: return_url,
    };
    return this.postForm({
      url: '/web/wallet/stars/recharge/order/create',
      params: {
        platform: 'web',
      },
      data,
    });
  }

  queryOrder(orderId: string) {
    const params: IQueryOrderRequest = {
      platform: 'web',
      order_id: orderId,
    };
    return this.get({
      url: '/web/wallet/stars/recharge/order/query',
      params,
    });
  }

  jumpCashier(payChannelUrl: string) {
    window.open(payChannelUrl, '_blank');
  }
}
const srvInstance = new PaymentService();

export default srvInstance;


